import type { Maybe } from '../../apis/graphql';
import { UNRECOGNIZED } from '../../configs';
import type { DropdownOption } from '../Dropdown';
import type { LabelTransformationFunction } from './config';
import { BILLED_DROPDOWN_OPTION, DropdownOptions } from './config';

type QueryNode = {
  name: Maybe<string>;
  id: string;
};

export const prepareDropdownOptions = (
  options: string[],
  dropdownOption: DropdownOptions,
  labelTransform?: LabelTransformationFunction
): DropdownOption<string>[] => {
  const preparedOptions = options
    .map((option) => {
      const labelValue = labelTransform ? labelTransform(option) : option;

      return {
        value: option,
        label: labelValue,
      };
    })
    .filter((option) => option.label !== UNRECOGNIZED);

  if (dropdownOption === DropdownOptions.LineItemBillableThirdParties) {
    return [BILLED_DROPDOWN_OPTION, ...preparedOptions];
  }

  return preparedOptions;
};

export const prepareQueryNodeAsDropdownOptions = (
  options: QueryNode[],
  labelTransform?: LabelTransformationFunction
): DropdownOption<string>[] => {
  const preparedOptions = options.map((option) => {
    const optionName = option.name ?? '';
    const labelValue = labelTransform ? labelTransform(optionName) : optionName;

    return {
      value: option.id,
      label: labelValue,
    };
  });

  return preparedOptions;
};

export const convertQueryResultToDropdownOptions = <T extends QueryNode>(
  queryResult?: { edges: { node: T }[] } | null
): DropdownOption[] => {
  return (
    queryResult?.edges
      .map(({ node }) => ({
        label: node.name ?? '',
        value: node.id,
      }))
      .sort((a, b) => a.label.localeCompare(b.label)) || []
  );
};
